(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/helpers/marketplace-helpers.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/helpers/marketplace-helpers.js'); "use strict";

svs.tipset.helpers = {};

var getMarketplaceAccount = function getMarketplaceAccount() {
  var marketplace = svs.components.marketplace;

  if (marketplace && marketplace.accountSelector) {
    return marketplace.accountSelector.helpers.getCurrentAccount();
  }

  return undefined;
};

svs.tipset.helpers = {
  getMarketplaceAccount: getMarketplaceAccount
};
 })(window);